import { render, staticRenderFns } from "./ProjectSharedResource.vue?vue&type=template&id=87371018&scoped=true&"
import script from "./ProjectSharedResource.vue?vue&type=script&lang=js&"
export * from "./ProjectSharedResource.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSharedResource.vue?vue&type=style&index=0&id=87371018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87371018",
  null
  
)

export default component.exports